module.exports = __webpack_public_path__ + "img/sandstone.bc1c5429.jpg";